module.exports = "pegasus/assets/blocks/column-lp12-themelp1.png";